import { type PropsWithChildren } from 'react';
import { RouterProvider } from 'react-aria-components';
import { useHref, useNavigate } from 'react-router-dom';
import type { NavigateOptions } from 'react-router-dom';

declare module 'react-aria-components' {
  interface RouterConfig {
    routerOptions: NavigateOptions;
  }
}

/**
 * Bridges react-router into React Aria Components so Untitled UI links and
 * buttons that accept an `href` use the SPA navigation instead of a full
 * page reload. Must render INSIDE the project's BrowserRouter.
 */
export const RouteProvider = ({ children }: PropsWithChildren) => {
  const navigate = useNavigate();

  return (
    <RouterProvider navigate={navigate} useHref={useHref}>
      {children}
    </RouterProvider>
  );
};
